import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./joinPage.css";
import "../../Styles/common-styles.css";
import "../Styles/common-formstyle.css";
import { toast } from "react-toastify";
import kleidologo from "../../../../assets/images/Kleido.png";

const JoinPage = () => {
  const navigate = useNavigate();
  const loggedInUser = JSON.parse(localStorage.getItem("userLoggedin"));

  // Institute → Location mapping
  const instituteOptions = {
    "Indian Institute of Technology (IIT)": [
      "Delhi",
      "Mumbai",
      "Kanpur",
      "Madras",
      "Kharagpur",
    ],
    "Indian Institute of Management (IIM)": [
      "Bangalore",
      "Ahmedabad",
      "Kozhikode",
    ],
    "Indian Institute of Science (IISc)": ["Bangalore"],
    "All India Institute of Medical Sciences (AIIMS)": [
      "Delhi",
      "Bhubaneswar",
    ],
  };

  const branchOptions = ["Computer Science", "Electronics"];

  const [formData, setFormData] = useState({
    userId: "",
    userName: "",
    institute: "",
    location: "",
    sessionFrom: "",
    sessionTo: "",
    branch: "",
    currentLocation: "",
    profileImage: null,
  });

  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [userid, setUserid] = useState("");




  // Auto-fill User ID
  useEffect(() => {
    if (loggedInUser?.userId) {
      setFormData((prev) => ({ ...prev, userId: loggedInUser.userId }));
      setUserid(loggedInUser.userId);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // reset location on changing institute
    if (name === "institute") {
      setFormData((prev) => ({
        ...prev,
        institute: value,
        location: "",
      }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    setFormData((prev) => ({ ...prev, profileImage: file }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!acceptedTerms) {
      setErrorMessage("You must accept the Terms and Conditions.");
      return;
    }

    console.log("Join request data:", formData);

    toast.info(
      "Your join request has been submitted. A moderator will review it.",
      { position: "top-center", autoClose: 3500 }
    );

    setTimeout(() => navigate("/"), 3500);
  };

  return (
    <div className="su-auth-container" style={{marginTop: 5}}>
      <div className="signup-box">
        <div className="form-box-header">
          <h2>Join Us</h2>
          <img src={kleidologo} className="logo-default-container-img" />
        </div>

        {errorMessage && <p className="error-message">{errorMessage}</p>}

        <form onSubmit={handleSubmit}>
          {/* USER ID (Auto-filled, but label removed as requested) */}
          <div className="form-group-row">
            <div className="form-group">
              <label>* User ID</label>
              <input
                type="text"
                name="userId"
                value={formData.userId}
                disabled
                style={{ background: "#e0e0e0", color: "black" }}
              />
            </div>
          </div>

          {/* USER NAME */}
          <div className="form-group-row">
            <div className="form-group">
              <label>* Full Name</label>
              <input
                type="text"
                name="userName"
                value={formData.userName}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {/* INSTITUTE + LOCATION (same row, dropdowns) */}
          <div className="form-group-row">
            <div className="form-group">
              <label>* Institute</label>
              <select
                name="institute"
                value={formData.institute}
                onChange={handleChange}
                required
              >
                <option value="">Select Institute</option>
                {Object.keys(instituteOptions).map((inst, idx) => (
                  <option key={idx} value={inst}>
                    {inst}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>* Location</label>
              <select
                name="location"
                value={formData.location}
                onChange={handleChange}
                required
                disabled={!formData.institute}
              >
                <option value="">Select Location</option>
                {formData.institute &&
                  instituteOptions[formData.institute].map((loc, idx) => (
                    <option key={idx} value={loc}>
                      {loc}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          {/* SESSION FROM / TO */}
          <div className="form-group-row">
            <div className="form-group">
              <label>* Session From</label>
              <input
                type="date"
                name="sessionFrom"
                value={formData.sessionFrom}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>* Session To</label>
              <input
                type="date"
                name="sessionTo"
                value={formData.sessionTo}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {/* BRANCH (dropdown) */}
          <div className="form-group-row">
            <div className="form-group">
              <label>* Branch</label>
              <select
                name="branch"
                value={formData.branch}
                onChange={handleChange}
                required
              >
                <option value="" style={{height: 40}}>Select Branch</option>
                {branchOptions.map((b, idx) => (
                  <option key={idx} value={b}>
                    {b}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* CURRENT LOCATION + PROFILE IMAGE (same row) */}
          <div className="form-group-row">
            <div className="form-group" style={{width: "70%"}}>
              <label>* Current Location</label>
              <input
                type="text"
                name="currentLocation"
                value={formData.currentLocation}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group" style={{ width: "30%"}}>
              <label>Profile Image</label>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
                style={{marginTop: 18, height: 70}}
              />
              {formData.profileImage && (
                <p style={{ fontSize: 12 }}>Selected: {formData.profileImage.name}</p>
              )}
            </div>
          </div>

          {/* TERMS */}
          <div className="form-group" style={{ marginTop: 20 }}>
            <input
              type="checkbox"
              id="terms"
              checked={acceptedTerms}
              onChange={() => setAcceptedTerms(!acceptedTerms)}
            />
            <label htmlFor="terms" style={{ marginLeft: 5 }}>
              I accept the{" "}
              <Link to="/privacy-policy" target="_blank">
                Terms & Conditions
              </Link>
            </label>
          </div>

          {/* SUBMIT */}
          <div className="form-group-row" style={{ marginTop: 15 }}>
            <button className="submit-btn" disabled={!acceptedTerms}>
              Submit
            </button>
          </div>

          <p className="signin-prompt">
            Already registered? <Link to={`/community-page/${userid}/home`}>Community Page</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default JoinPage;
